/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService
 */
import * as References from './ScopeGapsService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getProductHierarchy
 */
export const GET_PRODUCT_HIERARCHY_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_ScopeGapsService_getProductHierarchy';
export const GET_PRODUCT_HIERARCHY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCT_HIERARCHY_QUERY_FIELD_NAME,
  args: ['frontendLocale', 'javaLocaleLanguageTag'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getProductHierarchyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getSatisfyingOptions
 */
export const GET_SATISFYING_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_ScopeGapsService_getSatisfyingOptions';
export const GET_SATISFYING_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SATISFYING_OPTIONS_QUERY_FIELD_NAME,
  args: ['scopes', 'scopeGroups', 'minimal', 'frontendLocale', 'javaLocaleLanguageTag'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSatisfyingOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getSatisfyingCombos
 */
export const GET_SATISFYING_COMBOS_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_ScopeGapsService_getSatisfyingCombos';
export const GET_SATISFYING_COMBOS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SATISFYING_COMBOS_QUERY_FIELD_NAME,
  args: ['scopes', 'scopeGroups', 'minimal', 'frontendLocale', 'javaLocaleLanguageTag'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getSatisfyingCombosRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getSatisfyingCombosBatch
 */
export const GET_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_ScopeGapsService_getSatisfyingCombosBatch';
export const GET_SATISFYING_COMBOS_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME,
  args: ['requests'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getSatisfyingCombosBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getFullSatisfyingCombos
 */
export const GET_FULL_SATISFYING_COMBOS_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_ScopeGapsService_getFullSatisfyingCombos';
export const GET_FULL_SATISFYING_COMBOS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FULL_SATISFYING_COMBOS_QUERY_FIELD_NAME,
  args: ['scopes', 'scopeGroups', 'minimal', 'frontendLocale', 'javaLocaleLanguageTag'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getFullSatisfyingCombosRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getFullSatisfyingCombosBatch
 */
export const GET_FULL_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_ScopeGapsService_getFullSatisfyingCombosBatch';
export const GET_FULL_SATISFYING_COMBOS_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FULL_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME,
  args: ['requests'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getFullSatisfyingCombosBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});